import { useEffect, useState } from 'react';
import { toast } from 'sonner';

/** Online/offline as React state, with the 8m toast when connectivity returns. Offline itself is a badge, never a toast. */
export function useOnline(): boolean {
  const [online, setOnline] = useState(() => (typeof navigator === 'undefined' ? true : navigator.onLine));
  useEffect(() => {
    const on = () => { setOnline(true); toast('Back online', { description: 'The timer never needed the network - nothing was lost.' }); };
    const off = () => setOnline(false);
    window.addEventListener('online', on); window.addEventListener('offline', off);
    return () => { window.removeEventListener('online', on); window.removeEventListener('offline', off); };
  }, []);
  return online;
}
